import React from 'react'

import { Grid, GridItem } from '@chakra-ui/react'

import ConstituentDetailsBox from './ConstituentDetailsBox'
import DistrictBox from './DistrictBox'
import NameBox from './NameBox'

const ConstituentProfile = () => {
  return (
    <Grid
      aria-label='constituent-profile-grid'
      gridTemplateRows={{ base: '1fr', lg: '0.5fr 3fr' }}
      gridTemplateColumns={{ base: '1fr', lg: '1.5fr 0.75fr' }}
      templateAreas={{
        base: `
        "name"
        "details"
        "district"
        `,
        lg: `
          "name district"
          "details district"
        `,
      }}
      gap={3}
      p={3}
      maxW='7xl'
    >
      <GridItem area='name'>
        <div>
          <NameBox className='print-scale' />
        </div>
      </GridItem>
      <GridItem area='district'>
        <div className='print-scale'>
          <DistrictBox />
        </div>
      </GridItem>
      <GridItem area='details'>
        <div className='print-scale'>
          <ConstituentDetailsBox />
        </div>
      </GridItem>
    </Grid>
  )
}

export default ConstituentProfile
